import moment from "core/utils/moment";
import { numberFormat } from "core/utils/string";

export default function interpolationFormat(value, format, lng) {
  moment.locale(lng);

  if (format === "forStream") {
    if (lng === "ru") {
      return moment(value).format("D MMMM [в] HH:mm");
    }

    if (lng === "pl") {
      return moment(value).format("D MMMM [o godzinie] HH:mm");
    }

    if (lng === "de") {
      return moment(value).format("[am] D[.] MMMM [um] HH:mm");
    }

    if (lng === "es") {
      return moment(value).format("[el] D [de] MMMM [a las] HH:mm");
    }

    return moment(value).format("[on] MMMM[,] D YYYY [at] hh:mm A");
  }

  if (format === "dateMonth") {
    if (lng === "de") {
      return moment(value).format("D[.] MMM YYYY");
    }

    if (lng === "es") {
      return moment(value).format("DD MMM YYYY");
    }

    return moment(value).format("DD MMM YYYY");
  }

  if (format === "onlyDate") {
    if (lng === "de") {
      return moment(value).format("D[.] MMMM YYYY");
    }

    if (lng === "es") {
      return moment(value).format("D [de] MMMM [de] YYYY");
    }

    return moment(value).format("D MMMM YYYY");
  }

  if (format === "short") {
    if (lng === "en") {
      return moment(value).format("MM/DD/YYYY hh:mm A");
    }
    if (lng === "de") {
      return moment(value).format("DD/MM/YYYY HH:mm");
    }
    if (lng === "es") {
      return moment(value).format("DD/MM/YYYY HH:mm");
    }
    return moment(value).format("DD.MM.YYYY HH:mm");
  }

  if (format === "full") {
    if (lng === "en") {
      return moment(value).format("D MMMM YYYY hh:mm A");
    }
    if (lng === "de") {
      return moment(value).format("D[.] MMMM YYYY HH:mm");
    }
    if (lng === "es") {
      return moment(value).format("D [de] MMMM [de] YYYY HH:mm");
    }
    return moment(value).format("DD MMMM YYYY HH:mm");
  }

  if (format === "time") {
    if (lng === "en") {
      return moment(value).format("hh:mm A");
    }

    return moment(value).format("HH:mm");
  }

  if (format === "dateMonthFull") {
    if (lng === "en") {
      return moment(value).format("MMMM[,] D YYYY");
    }
    if (lng === "de") {
      return moment(value).format("D[.] MMMM YYYY");
    }
    if (lng === "es") {
      return moment(value).format("D [de] MMMM [de] YYYY");
    }
    return moment(value).format("D MMMM YYYY");
  }

  if (format === "scheduled") {
    if (lng === "ru") {
      return moment(value).format("DD MMMM [в] HH:mm");
    }

    if (lng === "pl") {
      return moment(value).format("DD MMMM HH:mm");
    }

    if (lng === "de") {
      return moment(value).format("D[.] MMMM [um] HH:mm");
    }

    if (lng === "es") {
      return moment(value).format("DD [de] MMMM [a las] HH:mm");
    }

    return moment(value).format("DD MMMM [at] hh:mm А");
  }

  if (format === "local") {
    return moment(value).format("LLL");
  }

  if (format === "fromNow") {
    return moment(value).fromNow(true); // 4 years
  }

  if (format === "fromNowAgo") {
    return moment(value).fromNow(); // 4 years ago
  }

  if (format === "numberFormat") {
    if (lng === "ru") {
      let si = [
        { value: 1, symbol: "" },
        { value: 1e3, symbol: " тыс." },
        { value: 1e6, symbol: " млн" },
        { value: 1e9, symbol: " млрд" },
        { value: 1e12, symbol: " трлн" },
      ];

      return numberFormat(value, 1, si);
    } else {
      let si = [
        { value: 1, symbol: "" },
        { value: 1e3, symbol: "K" },
        { value: 1e6, symbol: "M" },
        { value: 1e9, symbol: "B" },
        { value: 1e12, symbol: "T" },
      ];

      return numberFormat(value, 1, si);
    }
  }
  return value;
}
